export default "/assets/open_book-a5631d98d49b64d1cecc1df3aef7d89fb5cd9c5be39744943dcf26cb8795b825.svg";